import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'
import {
  EMPLOYEE_STAFF_CLOSE_RIGHT_COLUMN,
  EMPLOYEE_STAFF_OPEN_RIGHT_COLUMN,
  EMPLOYEE_STAFF_SET_EMPLOYEES,
  EMPLOYEE_STAFF_SET_SUBMITTING,
  EMPLOYEE_STAFF_SET_EMPLOYEE_DETAIL,
  EMPLOYEE_STAFF_SET_OUTLETS,
  EMPLOYEE_STAFF_SET_ROLES,
  EMPLOYEE_STAFF_SHOW_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_STAFF_HIDE_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_STAFF_SHOW_EMPLOYEE_DELETE_MODAL,
  EMPLOYEE_STAFF_HIDE_EMPLOYEE_DELETE_MODAL,
  EMPLOYEE_STAFF_SHOW_RESEND_CAPTCHA_MODAL,
  EMPLOYEE_STAFF_HIDE_RESEND_CAPTCHA_MODAL,
  EMPLOYEE_STAFF_SET_RESEND_CAPTCHA_EMAIL,
  EMPLOYEE_STAFF_SET_CAN_ACCESS_ROLE,
  EMPLOYEE_STAFF_SHOW_PIN_REQUIRED_MODAL,
  EMPLOYEE_STAFF_HIDE_PIN_REQUIRED_MODAL,
  EMPLOYEE_STAFF_SET_PIN_REQUIRED_MODAL
} from 'actions/employees/staff/constants'

const initialState = {
  openRightColumn: false,
  employees: [],
  outlets: [],
  roles: [],
  employeeDetail: null,
  submitting: null,
  showAssignOutletModal: false,
  showEmployeeDeleteModal: false,
  showResendCaptchaModal: false,
  showPinRequiredModal: false,
  pinRequiredModal: {
    message: ''
  },
  resendCaptchaEmail: null,
  canAccessRole: null
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  const {payload} = action

  switch (action.type) {
    case EMPLOYEE_STAFF_CLOSE_RIGHT_COLUMN:
      return {...state, openRightColumn: false}
    case EMPLOYEE_STAFF_OPEN_RIGHT_COLUMN:
      return {...state, openRightColumn: true}
    case EMPLOYEE_STAFF_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case EMPLOYEE_STAFF_SET_EMPLOYEES:
      return {...state, employees: payload.employees}
    case EMPLOYEE_STAFF_SET_ROLES:
      return {...state, roles: payload.roles}
    case EMPLOYEE_STAFF_SET_SUBMITTING:
      return {...state, submitting: payload.submitting}
    case EMPLOYEE_STAFF_SET_EMPLOYEE_DETAIL:
      return {...state, employeeDetail: payload.employee}
    case EMPLOYEE_STAFF_SHOW_ASSIGN_OUTLET_MODAL:
      return {...state, showAssignOutletModal: true}
    case EMPLOYEE_STAFF_HIDE_ASSIGN_OUTLET_MODAL:
      return {...state, showAssignOutletModal: false}
    case EMPLOYEE_STAFF_SHOW_EMPLOYEE_DELETE_MODAL:
      return {...state, showEmployeeDeleteModal: true}
    case EMPLOYEE_STAFF_HIDE_EMPLOYEE_DELETE_MODAL:
      return {...state, showEmployeeDeleteModal: false}
    case EMPLOYEE_STAFF_SHOW_RESEND_CAPTCHA_MODAL:
      return {...state, showResendCaptchaModal: true}
    case EMPLOYEE_STAFF_HIDE_RESEND_CAPTCHA_MODAL:
      return {...state, showResendCaptchaModal: false}
    case EMPLOYEE_STAFF_SET_RESEND_CAPTCHA_EMAIL:
      return {...state, resendCaptchaEmail: payload.email}
    case EMPLOYEE_STAFF_SET_CAN_ACCESS_ROLE:
      return {...state, canAccessRole: payload.canAccessRole}
    case EMPLOYEE_STAFF_SHOW_PIN_REQUIRED_MODAL:
      return {...state, showPinRequiredModal: true}
    case EMPLOYEE_STAFF_HIDE_PIN_REQUIRED_MODAL:
      return {...state, showPinRequiredModal: false}
    case EMPLOYEE_STAFF_SET_PIN_REQUIRED_MODAL:
      return {...state, pinRequiredModal: {...payload}}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/employees/staff.js